import {HttpAxiosRequest} from "../../httpAxiosBase";
import {EntityWithIdAndDescription} from "../../../types/baseEntities";

export const HttpCacheClientFolder = {
    getEndpoint: (url: string): string => `cache/cliente-carpeta${url}`,

    getComerciales: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(
            HttpCacheClientFolder.getEndpoint(`/comercial`)
        );
    },
}